import React from 'react';
import Login from '../component/Login';

const LoginContainer = () => (<Login />)

export default LoginContainer;
